// src/queries/listLibraryCardsQuery.js
// Lightweight list — selects only `entityId` per card. Mirrors GET_GALLERY_QUERY's
// working call signature (inline {tenantId, entityType} object) so it plays nicely
// with peaceful-oasis's own AppSync schema. Wrapped client-side as
// `{ pageNames: [...] }` so code ported verbatim from x20-creative works unchanged.
import { gql } from "@apollo/client";

export const LIST_LIBRARY_CARDS_QUERY = gql`
  query ListLibraryCardsEntityIds($tenantId: String!, $entityType: String!) {
    listLibraryCards(input: { tenantId: $tenantId, entityType: $entityType }) {
      entityId
    }
  }
`;
